const SET_FULL_SCREEN_INTELLEGANCE_CONTROL = "SET_FULL_SCREEN_INTELLEGANCE_CONTROL";

const requestSetFuulScreenAction = (fullScreen) => {
  return {
    type: SET_FULL_SCREEN_INTELLEGANCE_CONTROL,
    fullScreen,
  };
};

const setFullScreen = (fullScreen) => {
  return (dispatch) => {
    dispatch(requestSetFuulScreenAction(fullScreen));
  };
};

export { SET_FULL_SCREEN_INTELLEGANCE_CONTROL, setFullScreen };
